export namespace GarageEvents {
    export const buyCar = "GarageEvents_buyCar";
    export const buyUpgrade = "GarageEvents_buyUpgrade";
    export const buyPaint = "GarageEvents_buyPaint";
    export const repairCar = "GarageEvents_repairCar";
    export const buyLevel = "GarageEvents_buyLevel";
}

export namespace LevelEvents {
    export const showUI = "LevelEvents_showUI";
    export const showCollectable = "LevelEvents_showCollectable";
    export const hideCollectable = "LevelEvents_hideCollectable";
    export const showRepair = "LevelEvents_showRepair";
}

export namespace GeneratorEvenets {
    export const addObstacle = "addObstacle";
    export const addMoveableObstacle = "addMoveableObstacle";
    export const addCollectable = "addCollectable";
}

export namespace EngineEvents {
    export const highResTimer = "highResTimer";
    export const musicLoudness = "musicLoudness";
}

export namespace UIEvents {
    export const showSettings = "UIEvents_showSettings";
    export const showFTUE = "UIEvents_showFTUE";
    export const showError = "UIEvents_showError";
    export const showCredits = "UIEvents_showCredits";
}